export const Urls = {
  dfx: 'https://dfx.swiss',
  termsAndConditions: 'https://dfx.swiss/terms-and-conditions',
  privacyPolicy: 'https://dfx.swiss/privacy-policy',
  imprint: 'https://dfx.swiss/imprint',
  referral: 'https://dfx.swiss/app/services',
} as const;
